import { render, staticRenderFns } from "./PhotoManager.vue?vue&type=template&id=4f585850&scoped=true&"
import script from "./PhotoManager.vue?vue&type=script&lang=ts&"
export * from "./PhotoManager.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoManager.vue?vue&type=style&index=0&id=4f585850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f585850",
  null
  
)

export default component.exports